import React from 'react';

export const TermsPage: React.FC = () => {
    return (
        <div className="min-h-screen bg-[var(--surface-1)]">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20 animate-fade-in">
                <div className="max-w-4xl mx-auto">
                    <div className="text-center mb-12">
                        <h1 className="text-4xl sm:text-5xl font-bold text-[var(--text-1)] font-serif mb-4">
                            Terms & Conditions
                        </h1>
                        <p className="text-[var(--text-3)]">Last updated: January 15, 2025</p>
                    </div>

                    <div className="bg-[var(--surface-2)] rounded-3xl shadow-xl border border-[var(--surface-4)] p-8 sm:p-12 space-y-8">
                        <section>
                            <h2 className="text-2xl font-bold text-[var(--text-1)] mb-4">1. Acceptance of Terms</h2>
                            <p className="text-[var(--text-2)] leading-relaxed">
                                By accessing and using CompareLens, you accept and agree to be bound by the terms and provision
                                of this agreement. If you do not agree to these terms, please do not use our service.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-[var(--text-1)] mb-4">2. Use of Service</h2>
                            <p className="text-[var(--text-2)] leading-relaxed mb-3">
                                CompareLens provides AI-powered laptop recommendations and comparisons. Our service is provided
                                as-is for informational purposes. You agree to use the service only for lawful purposes and
                                in accordance with these terms.
                            </p>
                            <ul className="list-disc list-inside text-[var(--text-2)] space-y-2 ml-4">
                                <li>You must not misuse our service or attempt to access it using unauthorized methods</li>
                                <li>You must not use automated systems to access or scrape our content</li>
                                <li>You must not transmit any harmful code or interfere with the service</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-[var(--text-1)] mb-4">3. Recommendations and Accuracy</h2>
                            <p className="text-[var(--text-2)] leading-relaxed">
                                While we strive to provide accurate and up-to-date information, our AI-generated recommendations
                                are for informational purposes only. We do not guarantee the accuracy, completeness, or reliability
                                of any information provided. You should verify product specifications and pricing with official
                                retailers before making any purchase decisions.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-[var(--text-1)] mb-4">4. Intellectual Property</h2>
                            <p className="text-[var(--text-2)] leading-relaxed">
                                All content, features, and functionality of CompareLens, including but not limited to text, graphics,
                                logos, and software, are owned by CompareLens and are protected by international copyright, trademark,
                                and other intellectual property laws.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-[var(--text-1)] mb-4">5. Third-Party Links</h2>
                            <p className="text-[var(--text-2)] leading-relaxed">
                                Our service may contain links to third-party websites or services that are not owned or controlled
                                by CompareLens. We have no control over and assume no responsibility for the content, privacy policies,
                                or practices of any third-party websites or services.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-[var(--text-1)] mb-4">6. Limitation of Liability</h2>
                            <p className="text-[var(--text-2)] leading-relaxed">
                                In no event shall CompareLens, its directors, employees, or affiliates be liable for any indirect,
                                incidental, special, consequential, or punitive damages, including without limitation, loss of profits,
                                data, or other intangible losses, resulting from your use of or inability to use the service.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-[var(--text-1)] mb-4">7. Changes to Terms</h2>
                            <p className="text-[var(--text-2)] leading-relaxed">
                                We reserve the right to modify or replace these terms at any time. If a revision is material, we will
                                provide notice prior to any new terms taking effect. Your continued use of the service after any changes
                                constitutes acceptance of those changes.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-[var(--text-1)] mb-4">8. Governing Law</h2>
                            <p className="text-[var(--text-2)] leading-relaxed">
                                These terms shall be governed and construed in accordance with applicable laws, without regard to its
                                conflict of law provisions.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-[var(--text-1)] mb-4">9. Contact Information</h2>
                            <p className="text-[var(--text-2)] leading-relaxed">
                                If you have any questions about these Terms & Conditions, please contact us at:
                            </p>
                            <div className="mt-4 p-4 bg-[var(--surface-3)] rounded-lg">
                                <p className="text-[var(--text-2)]">
                                    Email: <a href="mailto:legal@laptopai.com" className="text-[var(--brand)] hover:underline">legal@laptopai.com</a>
                                </p>
                            </div>
                        </section>
                    </div>

                    <div className="text-center mt-8">
                        <a
                            href="/"
                            className="text-[var(--brand)] hover:text-[var(--brand-hover)] font-semibold transition-colors"
                        >
                            Back to Home
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
